<span class="mas-button-set" *ngIf="buttons.length > 0">
  <button
    class="btn"
    [ngClass]="{ 'btn-secondary': !btn.active, 'btn-primary': btn.active }"
    (click)="onClick(btn)"
    *ngFor="let btn of buttons"
  >
    {{ btn.text }}
  </button>
</span>
